import MessageNotificator from "./services/MessageNotificator"

export default {
    methods: {
        messageNotificator() {
            return new MessageNotificator()
        }
    }
}
